var render = function render(){var _vm=this,_c=_vm._self._c;return _c('m-container',{staticClass:"auth-scene",attrs:{"contentClass":"auth-scene__inner"}},[_c('icon-logo',{staticClass:"auth-scene__logo",attrs:{"animation":""}}),_c('article',{staticClass:"auth-scene__card"},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }